<div
  (inViewportAction)="handleSpacerViewport($event)"
  [inViewportOptions]="{threshold: 0}"
  [ngStyle]="{'height.px': topSearchSpacerHeight()}"
  class="top-search-spacer"
  inViewport
></div>
